import { failureType, requestType, successType } from 'src/services/api-handlers/api-resolver';
import { Paginated } from '../../services/api-handlers/pagination';

import { Actions } from '../actions/seanceReport-actions';
import { SeanceReportActions } from '../constants';
import { ISeanceReport } from 'src/types/seanceReport';

export interface SeanceReportState {
    inProgress: boolean;
    authCode: string;
    error: string;
    totals: any;
    data: Paginated<ISeanceReport>;
    current: ISeanceReport | null;
    currentFiles: any | null;
}

const initialState = {
    inProgress: false,
    authCode: '',
    error: '',
    totals: {},
    data: {
        inProgress: false,
        list: [],
        page: 1,
        meta: {
            updatedAt: null,
        },
    },
    current: null,
    currentFiles: null,
};

export function seanceReports(state: SeanceReportState = initialState, action: Actions | any): SeanceReportState {
    switch (action.type) {
        case requestType(SeanceReportActions.PERSIST_SEANCE_REPORT):
            return { ...state, error: '', inProgress: true };
        case successType(SeanceReportActions.PERSIST_SEANCE_REPORT):
            return { ...state, inProgress: false };
        case failureType(SeanceReportActions.PERSIST_SEANCE_REPORT):
            return { ...state, error: action.error, inProgress: false };

        case requestType(SeanceReportActions.FETCH_SEANCE_REPORTS):
            return {
                ...state,

                data: {
                    ...state.data,
                    list: [],
                    meta: state.data?.meta?.updatedAt
                        ? state.data?.meta
                        : {
                              updatedAt: null,
                          },
                    inProgress: true,
                },
                error: '',
                inProgress: true,
            };

        case successType(SeanceReportActions.FETCH_SEANCE_REPORTS_TOTAL):
            if (action.total) {
                return {
                    ...state,
                    totals: action.payload,
                    data: {
                        ...state.data,
                        ...action.payload,
                        list: Object.keys(action.payload).length
                            ? [action.payload, ...state.data.list]
                            : state.data.list,
                        inProgress: false,
                    },
                    inProgress: false,
                };
            }
            return state;
        case failureType(SeanceReportActions.FETCH_SEANCE_REPORTS_TOTAL):
            return { ...state, totals: {}, error: action.error, inProgress: false };
        case requestType(SeanceReportActions.FETCH_SEANCE_REPORTS_TOTAL):
            return { ...state, inProgress: true, totals: {}, error: '' };

        case successType(SeanceReportActions.FETCH_SEANCE_REPORTS):
            return {
                ...state,
                data: {
                    ...action.payload,
                    list: Object.keys(state.totals).length
                        ? [state.totals, ...action.payload.list]
                        : action.payload.list,
                    inProgress: false,
                },
                inProgress: false,
            };
        case failureType(SeanceReportActions.FETCH_SEANCE_REPORTS):
            return { ...state, data: { ...state.data, inProgress: false }, error: action.error, inProgress: false };

        case requestType(SeanceReportActions.FETCH_SEANCE_REPORT):
            return { ...state, inProgress: true, current: null, error: '' };
        case successType(SeanceReportActions.FETCH_SEANCE_REPORT):
            return { ...state, inProgress: false, current: action.payload };
        case failureType(SeanceReportActions.FETCH_SEANCE_REPORT):
            return { ...state, inProgress: false, error: action.error };
        case requestType(SeanceReportActions.DELETE_SEANCE_REPORT):
            return { ...state, error: '', inProgress: true };
        case successType(SeanceReportActions.DELETE_SEANCE_REPORT):
            return {
                ...state,
                inProgress: false,
                data: {
                    ...state.data,
                    list: state.data.list.filter((user: ISeanceReport) => {
                        return user.id !== action.payload.id;
                    }),
                    meta: {
                        updatedAt: 0,
                    },
                },
            };
        case failureType(SeanceReportActions.DELETE_SEANCE_REPORT):
            return { ...state, inProgress: false, error: action.error.response.data?.errorMessage ?? 'Unknown error' };
        default:
            return state;
    }
}
